import React from 'react';
import styles from './FooterText.module.css';

export const FooterText = () => {
    return (
        <div className={styles.footerText}>
            <p className={styles.text}>
                <span className={styles.textSpan}>
                    Howz!t © 2025 - Designed by Team Howz!t
                </span>
            </p>
        </div>
    );
};